export default "__VITE_ASSET__C2l8LJ_P__"